import { FC } from "react";

import TiledImageVertical from "@/components/BentoList/TiledImageVertical";
import TiledText from "@/components/BentoList/TiledText";
import { BentoElement, BentoElementType, BentoTextElement, EditorialModuleImage } from "@/types";

const TiledBlockVWithImage: FC<{ items: BentoElement[] }> = ({ items }) => {
  let texts: BentoTextElement[] = [];
  let image;
  items.forEach((item, index) => {
    if (item.type === BentoElementType.image) {
      image = item as EditorialModuleImage;
    } else if ((item.type = BentoElementType.text)) {
      texts.push(item as BentoTextElement);
    }
  });
  return (
    <div className="grid grid-cols-2 gap-xs h-full">
      {image && items[0].type === BentoElementType.image && <TiledImageVertical entry={image} slideIndex={0} />}

      <div className="grid gap-xs">
        {texts.map((text, index) => (
          <TiledText slideIndex={index} key={text.id} entry={text} />
        ))}
      </div>

      {image && items[0].type === BentoElementType.text && <TiledImageVertical entry={image} slideIndex={2} />}
    </div>
  );
  /* if (image && items[0].type === BentoElementType.image) {
    return (
      <div className="grid grid-cols-2">
        <TiledImageVertical entry={image} slideIndex={0} key={0}></TiledImageVertical>
        <div className="col-span-1 grid grid-cols-1 gap-xs">
          {texts.map((text, index) => (
            <TiledText slideIndex={index + 1} key={`text-${index + 1}`} entry={text} />
          ))}
        </div>
      </div>
    );
  } else if (image && items[0].type === BentoElementType.text) {
    return (
      <div className="grid grid-cols-2">
        <div className="grid gap-xs">
          {texts.map((text, index) => (
            <TiledText slideIndex={index + 1} key={`text-${index + 1}`} entry={text} />
          ))}
        </div>
        <TiledImageVertical entry={image} slideIndex={2}></TiledImageVertical>
      </div>
    );
  } */
};

export default TiledBlockVWithImage;
